;( function( $ ) {

	$( function() {

		var $mobileMenu = $( document.getElementById( 'mobile-main-menu' ) ),
			$body       = $( 'body' ),
			$window     = $( 'window' );


		/** Main menu dropdown */
		$( '#primary-navigation .parent-links' ).hover( function() {
			$( this ).addClass( 'active' ).find( $( '.main-menu-dropdown' ) ).show();

		}, function() {
			$( this ).removeClass( 'active' ).find( $( '.main-menu-dropdown' ) ).hide();

		});


		/** Login dropdown */
		$( document.getElementById( 'upper-login-link' ) ).hover( function() {
			$( this ).addClass( 'active' ).find( $( '.login-dropdown' ) ).show();

		}, function() {
			$( this ).removeClass( 'active' ).find( $( '.login-dropdown' ) ).hide();

		});


		/** Sharing toggle */
		$( '.share-on' ).click( function() {
			$( this ).toggleClass('open');
		});


		/** Trigger mobile dropdown */
		$( document.getElementById( 'mob-menu-toggle' ) ).on( 'click', function( e ) {
			e.preventDefault();

			var $this = $( this ),
				top   = $( document ).scrollTop() + 45;

			// if ( $( window ).width() < 768 ) {
			//	$mobileMenu.css({ top: top });
			// }

			if ( $body.hasClass( 'map-open' ) ) {
				$( '.show-store-trigger' ).eq( 0 ).trigger( 'click' );
			}
			$body.toggleClass( 'mobile-menu-open' );

			if ( $this.hasClass( 'active' ) ) {
				$( '.parent-a', $mobileMenu ).removeClass( 'active' );
				$( '.main-menu-dropdown' ).slideUp( 100 );
			}

			$( this ).toggleClass( 'active' );
			$mobileMenu.slideToggle( 100 );
		});


		/** Trigger mobile user-link dropdown */
		$( document.getElementsByClassName( 'user-link toggle' ) ).on( 'click', function( e ) {

			if ( window.outerWidth > 990 ) {
				return;
			}

			e.preventDefault();

			var $parent = $(this).parent();
			var $sub_menu = $( '.user-sub-links', $parent);

			if ( $sub_menu.is(':visible') ) {
				$( '.user-sub-links' ).hide();
			} else {
				$( '.user-sub-links' ).hide();
				$sub_menu.show();
			}
		});


		/** Mobile menu dropdown */
		$( '.parent-a', $mobileMenu ).on( 'click', function( e ) {
			var $this = $( this );

			if ( $( '.main-menu-dropdown', $this.parent() ).length !== 0 ) {
				e.preventDefault();

				if ( ! $this.hasClass( 'active' ) ) {
					$( '.parent-a', $mobileMenu ).removeClass( 'active' );
					$( '.main-menu-dropdown' ).slideUp( 100 );
				}

				$this.next().slideToggle( 100 );
				$this.toggleClass( 'active' );
			}
		});


		if ( $( window ).width() < 768 ) {
			$( document.getElementById( 's' ) ).attr( 'placeholder', nordsjo.search );
		}

		$( document.getElementById( 'loginform' ) ).on( 'focus', 'input', function( e ) {
			var text = $( this ).prev().addClass( 'active' ).text();
			$( this ).attr( 'placeholder', text );
		});



		/** Hide menu on scroll down. Show on scroll up */
		var $didScroll;
		var $lastScrollTop = 0;
		var $delta = 10;
		var $navbarHeight = $( '.header-main, .logged-in.admin-bar.header-main' ).outerHeight();

		if ( $( window ).width() > 749 ) {

			$( document ).scroll( function( event ){

				if ( $( document ).scrollTop() <= 30 ) {
					$( '.header-container' ).removeClass( 'nav-down' );
				} else {
					$didScroll = true;
				}
			});
		}

		setInterval( function() {
			if ( $didScroll ) {
				hasScrolled();
				$didScroll = false;
			}
		}, 50 );

		function hasScrolled() {
			var st = $( this ).scrollTop();

			// Make sure they scroll more than $delta
			if( Math.abs( $lastScrollTop - st ) <= $delta ) {
				return;
			}

			// If they scrolled down and are past the navbar, add class .nav-up.
			// This is necessary so you never see what is "behind" the navbar.
			if ( st > $lastScrollTop && st > $navbarHeight ){
				// Scroll Down
				$( '.header-container' ).addClass( 'nav-up' ).removeClass( 'nav-down' );

			} else if ( st + $( window ).height() < $( document ).height() ) {
				// Scroll Up
				$( '.header-container' ).removeClass( 'nav-up' ).addClass( 'nav-down' );
			}

			$lastScrollTop = st;
		}

		/* detect touch device javascript */
		function is_touch_device() {
			var $DetectIfIsTouch = ( ( 'ontouchstart' in window ) || ( navigator.msMaxTouchPoints > 0 ) );
			// return !!( 'ontouchstart' in window );
			return $DetectIfIsTouch;
		}

		var $istouch = is_touch_device();
		if( $istouch === true ) {

			$( 'header .parent-a' ).on( 'click', function( e ) {
				if ( $( '.main-menu-dropdown', $this.parent() ).length !== 0 ) {
					e.preventDefault();
				}
			});

			$( '.login.user-link' ).on( 'click', function( e ) {
				e.preventDefault();
			});

		}


	});

}( jQuery ));
